( function( $ ) {
	$( document ).ready( function() {

		/**
		 * FAQ form submission.
		 */
		$( '#maina_product_faqs_question_form' ).on( 'submit', function( e ) {
			e.preventDefault();

			var form = $( this );

			$.ajax( {
				url: form.attr( 'action' ),
				data: form.serialize(),
				type: 'POST',
				dataType: 'json',
				beforeSend: function() {
					form.find( 'input[type="submit"]' ).attr( 'disabled','disabled' );
				},
				success: function ( response ) {
					form.trigger( 'reset' );
					form.find( 'input[type="submit"]' ).removeAttr( 'disabled' );

					// Trigger action when question form is successfully submitted.
					$( document.body ).trigger( 'maina_product_faqs_question_form_submitted' );
				}
			} );
		} );

		/**
		 * Useful or not useful is pressed.
		 */
		$( document ).on( 'click', '.product-faq-list .product-faq-is-useful button', function() {
			var el     = $( this );
			var parent = el.closest( '.product-faq-is-useful' );
			var useful = el.hasClass( 'useful' ) ? 'y' : 'n';

			if ( 0 < parent.find( 'button:disabled' ).length ) {
				return false;
			}

			$.ajax( {
				url: productFaqs.ajaxurl,
				type: 'post',
				dataType: 'json',
				data: {
					'action': 'maina_product_faqs_add_useful',
					'faq_id': el.data( 'faq-id' ),
					'useful': useful
				},
				beforeSend: function() {
					el.attr( 'disabled', 'disabled' );
				},
				success: function( response ) {
					if ( response.success ) {
						parent.find( 'button:nth-of-type(1) span' ).text( response.yes );
						parent.find( 'button:nth-of-type(2) span' ).text( response.no );
						if ( el.hasClass( 'useful-selected' ) ) {
							el.removeClass( 'useful-selected' );
						} else {
							el.siblings( 'button' ).removeClass( 'useful-selected' );
							el.addClass( 'useful-selected' );
						}
					}
				},
				complete: function() {
					el.removeAttr( 'disabled' );
				}
			} );
		} );

		/**
		 * Toggle question.
		 */
		$( '.product-faq-list .faq strong' ).on( 'click', function() {
			$( this ).toggleClass( 'active' ).next( 'div' ).slideToggle();
		} );

	} );
} )( jQuery );
